const SOURCE_LABEL: Record<string, string> = {
  hackernews: 'Hacker News',
  gdelt: 'News (GDELT)',
  github: 'GitHub',
  youtube: 'YouTube',
  reddit: 'Reddit',
  tiktok: 'TikTok',
  bluesky: 'Bluesky',
};

export function trendSourceLabel(source: string): string {
  return SOURCE_LABEL[source] ?? source;
}
